import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
  Summary as SecondarySummary,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const FullDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const BottomItem = styled.div`
  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    min-inline-size: 0;
  }
`;

export const BottomDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    flex: none;
    align-self: stretch;

    inline-size: 1px;
    block-size: auto;
  }
`;

export const StyledSecondaryItem = styled(ContentItemHomeSecondaryV2)`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
  }

  ${SecondaryHeadline} {
    font-size: 14px;
    line-height: 1.4;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  ${FullDivider},
  ${BottomRow} {
    order: 2;
  }

  ${theme.breakpoints.up("tablet")} {
    ${FullDivider},
    ${BottomRow} {
      order: 0;
    }
  }
`;

export const HeroImageLink = styled(EntityLink)`
  order: 1;

  display: block;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    order: 0;
  }
`;

export const StyledContentCoverImage = styled(ContentCoverImage)``;

export const SeriesRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SCMPSeriesLink = styled(BaseLink)`
  color: #2c4692;
  font-weight: 400;
  font-size: 15px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: normal;

  border-block-end: 1px dashed #2c3792;
`;

export const SeriesShortLabelLink = styled(EntityLink)`
  color: #2c4692;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: normal;
`;

export const StyledSeriesPrimary = styled(ContentItemHomeSecondaryV2)`
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 594px;
  }

  ${SecondaryHeadline} {
    font-weight: 300;
    font-size: 24px;
    line-height: 1.4;

    ${theme.breakpoints.up("tablet")} {
      font-size: 28px;
    }
  }

  ${SecondarySummary} {
    color: #5a5a5a;
    font-size: 14px;
    line-height: 1.5;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;
